<template>
	<section id="mobile-header">
		<div class="bar">
			<button class="icon-btn" aria-label="메뉴" @click="open = true">
				<svg viewBox="0 0 24 24"><path d="M4 7h16M4 12h16M4 17h16" /></svg>
			</button>
			<img class="logo" src="@/assets/svg/logo.svg" alt="LAB MANAGER STORE" @click="go({ name: PageName.Main })" />
			<button class="icon-btn cart" aria-label="장바구니" @click="go({ name: PageName.Cart })">
				<svg viewBox="0 0 24 24"><path d="M6 8h12l1 12H5L6 8zM9 8a3 3 0 0 1 6 0" /></svg>
				<i v-if="cartCount">{{ cartCount }}</i>
			</button>
		</div>

		<!-- 메뉴 서랍 -->
		<div class="drawer-wrap" :class="{ open }">
			<div class="dim" @click="open = false"></div>
			<nav class="drawer">
				<div class="drawer-top">
					<template v-if="isLoginUser">
						<b>{{ userName }}</b>
						<span v-if="institute" class="credit" @click="go({ name: PageName.MyPage.UnPaymentManagement, params: { step: 1 } })">
							후불한도 {{ (institute.limitCredit || 0).toLocaleString() }}원 ▸
						</span>
					</template>
					<template v-else>
						<button class="login" @click="goLogin">로그인 · 회원가입</button>
					</template>
					<button class="close" aria-label="닫기" @click="open = false">✕</button>
				</div>

				<ul class="menu">
					<li @click="goPro">
						<img src="@/assets/svg/icon-lmp-favicon.svg" />
						랩매니저 Pro
					</li>
					<li :class="{ active: isChemical }" @click="go({ path: '/search', query: { classification: '' } })">
						<svg viewBox="0 0 24 24"><path :d="icons.chemical" /></svg>
						화학물질
					</li>
					<li :class="{ active: $route.name === PageName.Supplies }" @click="go({ name: PageName.Supplies })">
						<svg viewBox="0 0 24 24"><path :d="icons.supplies" /></svg>
						실험용품/기기
					</li>
					<li @click="go({ name: PageName.List, params: { category: 'brand' } })">
						<svg viewBox="0 0 24 24"><path :d="icons.brand" /></svg>
						브랜드 관
					</li>
					<li @click="go({ name: PageName.CsCenter.EventManagement })">
						<svg viewBox="0 0 24 24"><path :d="icons.event" /></svg>
						이벤트
					</li>
				</ul>

				<ul class="menu sub" v-if="isLoginUser">
					<li @click="go({ name: PageName.MyPage.Order })">주문배송 내역</li>
					<li @click="go({ name: PageName.MyPage.LabInfoManagement })">연구실 정보</li>
					<li @click="go({ name: PageName.MyPage.UserInfo })">나의 정보</li>
					<li @click="go({ name: PageName.CsCenter.QuestionManagement })">고객센터</li>
					<li @click="doLogout">로그아웃</li>
				</ul>
				<ul class="menu sub" v-else>
					<li @click="go({ name: PageName.CsCenter.QuestionManagement })">고객센터</li>
				</ul>

				<button class="view-switch" @click="switchView">PC 버전 보기</button>
			</nav>
		</div>
		<modal-intro-pro ref="modal-intro-pro" />
	</section>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import cookies from 'vue-cookies'
import PageName from '@/utils/define/PageName'
import ModalIntroPro from '@/components/modal/ModalIntroPro.vue'
import { goToSSOMain, isLogin, getSYSUrl } from '@/services/api/common'
import { setViewMode } from '@/utils/device'

export default {
	name: 'MobileHeader',
	components: { ModalIntroPro },
	data() {
		return {
			PageName,
			open: false,
			isLoginUser: false,
			icons: {
				chemical: 'M9 3h6 M10 3v6L4.5 19a1.5 1.5 0 0 0 1.3 2.2h12.4a1.5 1.5 0 0 0 1.3-2.2L14 9V3 M7.5 14h9',
				supplies: 'M21 8l-9-5-9 5v8l9 5 9-5V8z M3 8l9 5 9-5 M12 13v8',
				brand: 'M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z M7.5 7.5h.01',
				event: 'M20 12v9H4v-9 M2 7h20v5H2z M12 21V7 M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z',
			},
		}
	},
	computed: {
		...mapState('institute', ['institute']),
		...mapState('user', ['myPageInfo']),
		...mapGetters('user', ['userInfo']),
		userName() {
			return this.userInfo?.name || '내 계정'
		},
		cartCount() {
			const count = this.myPageInfo?.cartCount
			if (!count) return 0
			return count < 99 ? count : '99+'
		},
		isChemical() {
			return this.$route.name === PageName.SearchList
		},
	},
	watch: {
		userInfo: {
			handler(val) {
				if (val && val.id) this.isLoginUser = true
			},
			immediate: true,
		},
		$route() {
			this.open = false
		},
		open(val) {
			document.body.style.overflow = val ? 'hidden' : ''
		},
	},
	methods: {
		...mapActions('user', ['logout']),
		go(location) {
			this.open = false
			this.$router.push(location).catch(() => {})
		},
		goLogin() {
			goToSSOMain()
		},
		goPro() {
			this.open = false
			if (isLogin() && cookies.get('introProModal_hide')) {
				let url = getSYSUrl()
				if (this.institute && this.institute.proInstituteId) {
					url += `/${this.institute.proInstituteId}/purchase/cargo?isStore=true`
				}
				location.href = url
			} else this.$refs['modal-intro-pro'].show()
		},
		async doLogout() {
			await this.logout()
			this.$router.go()
		},
		switchView() {
			setViewMode('pc')
		},
		// App.vue / mixins 에서 PC 헤더와 같은 이름으로 호출한다.
		hideSearchRecent() {},
	},
}
</script>

<style lang="scss" scoped>
$INK: #161616;
$YELLOW: #fabf14;

#mobile-header {
	position: sticky;
	top: 0;
	z-index: 100;
	background: #fff;
	border-bottom: 1px solid #eceef1;
	.bar {
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 52px;
		padding: 0 6px;
	}
	.logo {
		height: 18px;
		cursor: pointer;
	}
	.icon-btn {
		position: relative;
		width: 44px;
		height: 44px;
		display: flex;
		align-items: center;
		justify-content: center;
		svg {
			width: 24px;
			height: 24px;
			fill: none;
			stroke: $INK;
			stroke-width: 2;
			stroke-linecap: round;
			stroke-linejoin: round;
		}
		i {
			position: absolute;
			top: 5px;
			right: 3px;
			min-width: 17px;
			height: 17px;
			padding: 0 4px;
			border-radius: 9px;
			background: #ff4d4f;
			color: #fff;
			font-size: 10px;
			font-style: normal;
			font-weight: 700;
			line-height: 17px;
			text-align: center;
		}
	}

	.drawer-wrap {
		position: fixed;
		inset: 0;
		z-index: 200;
		pointer-events: none;
		.dim {
			position: absolute;
			inset: 0;
			background: rgba(0, 0, 0, 0.45);
			opacity: 0;
			transition: opacity 0.2s;
		}
		.drawer {
			position: absolute;
			top: 0;
			bottom: 0;
			left: 0;
			width: 82%;
			max-width: 340px;
			display: flex;
			flex-direction: column;
			overflow-y: auto;
			background: #fff;
			transform: translateX(-100%);
			transition: transform 0.22s;
		}
		&.open {
			pointer-events: auto;
			.dim {
				opacity: 1;
			}
			.drawer {
				transform: none;
			}
		}
	}
	.drawer-top {
		position: relative;
		display: flex;
		flex-direction: column;
		gap: 6px;
		padding: 22px 20px 18px;
		background: #fffbea;
		b {
			font-size: 1.05rem;
			font-weight: 800;
		}
		.credit {
			font-size: 0.85rem;
			color: #1f9d55;
			font-weight: 600;
		}
		.login {
			align-self: flex-start;
			height: 40px;
			padding: 0 20px;
			border-radius: 20px;
			background: $YELLOW;
			font-weight: 800;
		}
		.close {
			position: absolute;
			top: 10px;
			right: 8px;
			width: 36px;
			height: 36px;
			font-size: 1.1rem;
			color: #6b7280;
		}
	}
	.menu {
		margin: 0;
		padding: 8px 0;
		list-style: none;
		li {
			display: flex;
			align-items: center;
			gap: 12px;
			height: 52px;
			padding: 0 20px;
			font-size: 1rem;
			font-weight: 700;
			color: #374151;
			svg {
				width: 20px;
				height: 20px;
				fill: none;
				stroke: currentColor;
				stroke-width: 2;
				stroke-linecap: round;
				stroke-linejoin: round;
			}
			img {
				width: 20px;
				height: 20px;
			}
			&.active {
				color: $INK;
				box-shadow: inset 4px 0 0 $YELLOW;
				background: #fffdf3;
			}
		}
		&.sub {
			border-top: 1px solid #eceef1;
			li {
				height: 44px;
				font-size: 0.92rem;
				font-weight: 500;
				color: #6b7280;
			}
		}
	}
	.view-switch {
		margin: auto 20px 24px;
		height: 42px;
		border: 1px solid #dfe3e8;
		border-radius: 21px;
		font-size: 0.9rem;
		color: #6b7280;
	}
}
</style>
